import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const importData = api(({ registerId, file, sheet, mapping, filename, row }) =>
    mutate(
        gql`
            mutation ImportData(
                $file: String!
                $sheet: String!
                $filename: String!
                $row: Int!
                $mapping: JSONObject!
                $registerId: String!
            ) {
                importData(
                    registerId: $registerId
                    mapping: $mapping
                    file: $file
                    filename: $filename
                    sheet: $sheet
                    row: $row
                ) {
                    totalImported
                    invalidQuantity {
                        count
                        samples {
                            row
                            tag
                            value
                        }
                    }
                }
            }
        `,
        { file, sheet, mapping, filename, row, registerId },
        { returns: "importData" }
    )
)
